import { setPlayerId } from '../utils/playerId';

const fetch = require("node-fetch");

export const authStatus = (authenticated, email) => ({
  type: 'AUTH_STATUS',
  payload: { authenticated, email: email || null },
});

// Checked once on page load - if the browser's session cookie belongs to a
// logged-in account, this also switches localStorage over to that
// account's own player uuid, so history fetched/logged from here on is
// theirs rather than this browser's anonymous one.
export const checkAuthStatus = () => async (dispatch) => {
  try {
    const response = await fetch('/api/me', { credentials: 'same-origin' });
    const json = await response.json();
    if (json.authenticated) {
      if (json.player && json.player.uuid) {
        setPlayerId(json.player.uuid);
      }
      dispatch(authStatus(true, json.email));
    } else {
      dispatch(authStatus(false, null));
    }
  } catch (error) {
    dispatch(authStatus(false, null));
  }
};

export const logout = () => async (dispatch) => {
  try {
    await fetch('/api/logout', { method: 'POST', credentials: 'same-origin' });
  } catch (error) {
    // the session cookie expiring/being invalid already gets us to the
    // logged-out state we want, so a network hiccup here isn't fatal
  }
  dispatch(authStatus(false, null));
};
